import React from 'react';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import styled from 'styled-components';

const WorklogTimerCellContainer = styled.div`
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
`;

const TimeFormatCell = (props) => {
  const { cell } = props;

  const getHours = (duration) => {
    const hours = Math.floor(duration / 60);
    return hours;
  };
  const getMinutes = (duration) => {
    const minutes = Math.round(duration % 60);
    return minutes;
  };

  const formatTime = (time) => {
    const timeInMinutes = time * 60;
    return `${getHours(timeInMinutes)}h ${getMinutes(timeInMinutes)}m`;
  };

  return cell?.value ? (
    <WorklogTimerCellContainer className="flex center fg1">
      <div className="fx actr">{formatTime(cell?.value)}</div>
    </WorklogTimerCellContainer>
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
};

export default TimeFormatCell;
